import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';
import { EntityWithTitle, entityWithTitleSchema } from './entity-with-title';

export type Bonus = {
	id: number;
	account: EntityWithName;
	game: EntityWithTitle;
	currency: string;
	depositRate: number;
	activationThreshold: number;
	isLocked: boolean;
};

export const bonusSchema: ZodType<Bonus> = z.object({
	id: z.number(),
	account: entityWithNameSchema,
	game: entityWithTitleSchema,
	currency: z.string(),
	depositRate: z.number(),
	activationThreshold: z.number(),
	isLocked: z.boolean(),
});
